import { Component, Input, OnInit } from '@angular/core';
import * as L from 'leaflet';


@Component({
  selector: 'app-geomap',
  templateUrl: './geomap.component.html',
  styleUrls: ['./geomap.component.scss']
})
export class GeomapComponent implements OnInit {

  @Input() latitude: number;
  @Input() longitude: number;

  ngOnInit() {
    this.buildMap();
  }

  buildMap() {
    const corner1 = L.latLng(-90, -180);
    const corner2 = L.latLng(90, 180);
    const mapOptions = {
      zoomControl: false,
      minZoom: 1,
      maxZoom: 7,
      maxBounds: L.latLngBounds(corner1, corner2),
      maxBoundsViscosity: 1
    };
    const map = L.map('map', mapOptions).setView([this.latitude, this.longitude], 3);
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);
    const markerOptions = {
      radius: 8,
      stroke: true,
      weight: 1,
      color: '#fff',
      fillOpacity: 1,
      fillColor: '#34D1B0'
    };
    const marker = L.circleMarker([this.latitude, this.longitude], markerOptions).addTo(map);
  }
}
